export default "__VITE_PUBLIC_ASSET__3f98edc2__"